import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block border border-accent-300 text-accent-700 text-xs font-medium px-4 py-1 rounded-full mb-4">
            FAQ
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight max-w-2xl mx-auto">
            Perguntas Frequentes sobre<br />CSSBuy Spreadsheet
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            Respostas às dúvidas mais comuns dos utilizadores do portal
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((faq, index) => (
            <div
              key={faq.question}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <div className="px-5 md:px-6 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}